import { render, staticRenderFns } from "./enduserClosure.vue?vue&type=template&id=4d151286"
import script from "./enduserClosure.vue?vue&type=script&lang=js"
export * from "./enduserClosure.vue?vue&type=script&lang=js"
import style0 from "./enduserClosure.vue?vue&type=style&index=0&id=4d151286&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d151286')) {
      api.createRecord('4d151286', component.options)
    } else {
      api.reload('4d151286', component.options)
    }
    module.hot.accept("./enduserClosure.vue?vue&type=template&id=4d151286", function () {
      api.rerender('4d151286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enduserDeclaration/enduserClosure.vue"
export default component.exports